import {
  UPLOAD_RESULT_835_STATUS,
  UPLOAD_RESULT_835_UNKNOWN_STATUS,
} from "../constants/ImportConversion835Constants";

/**
 * Turns an upload history row into the pieces a result card renders.
 *
 * Kept out of the component so the two rules that actually have edge cases can be tested
 * directly:
 *
 * 1. A row whose status the map does not recognise falls back to a neutral card. Statuses are
 *    written by the server and constrained by a CHECK constraint, but an unrecognised value must
 *    degrade to a readable card rather than failing a property lookup and taking the page with
 *    it.
 * 2. ErrorMessage is only used when it actually carries text. A failed row with a null or blank
 *    message still needs to say something.
 *
 * @param {{ fileName?: string, uploadRequestStatus?: string, errorMessage?: string }} item
 * @returns {{ title: string, message: string, statusClass: string, icon: string }}
 */
export function getUploadResultPresentation(item) {
  const row = item || {};

  const presentation =
    UPLOAD_RESULT_835_STATUS[row.uploadRequestStatus] ||
    UPLOAD_RESULT_835_UNKNOWN_STATUS;

  const errorMessage =
    typeof row.errorMessage === "string" ? row.errorMessage.trim() : "";

  return {
    title: row.fileName
      ? `${presentation.title} \u2014 ${row.fileName}`
      : presentation.title,
    message: errorMessage || presentation.defaultMessage,
    statusClass: presentation.statusClass,
    icon: presentation.icon,
  };
}
